import GelHackButton from "./GelHackButton";

export default class GelHackToggleButton extends GelHackButton {
    constructor(states) {
        super(states);

        this._toggle = false;

        this._states.normalAlt = this._states.normalAlt || this._states.normal;
        this._states.overAlt = this._states.overAlt || this._states.over;
        this._states.downAlt = this._states.downAlt || this._states.down;
        this._states.iconAlt = this._states.iconAlt || this._states.icon;
        this._states.iconOverAlt = this._states.iconOverAlt || this._states.iconOver;
        this._states.iconDownAlt = this._states.iconDownAlt || this._states.iconDown;
    }

    onMouseClick(event) {
        if (this._enabled) {
            this.toggle = !this.toggle;
        }
        super.onMouseClick(event);
    }

    get toggle() {
        return this._toggle;
    }

    set toggle(value) {
        this._toggle = value;

        this._currentNormalTexture = this._toggle ? this._states.normalAlt : this._states.normal;
        this._currentOverTexture = this._toggle ? this._states.overAlt : this._states.over;
        this._currentDownTexture = this._toggle ? this._states.downAlt : this._states.down;
        this._currentIconTexture = this._toggle ? this._states.iconAlt : this._states.icon;
        this._currentIconOverTexture = this._toggle ? this._states.iconOverAlt : this._states.iconOver;
        this._currentIconDownTexture = this._toggle ? this._states.iconDownAlt : this._states.iconDown;

        this._states.normal && (this._background.texture = this._currentNormalTexture);
        this._states.icon && (this._icon.texture = this._currentIconTexture);
    }

    set enabled(value) {
        this._enabled = value;
    }
}